import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthenticationService} from "../services/authentication.service";
import {User} from "../models/user";
import {NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css'],
  imports: [
    ReactiveFormsModule,
    NgIf,
    RouterLink
  ],
  standalone: true
})
export class PasswordChangeComponent implements OnInit {
  user!: User;
  errorText!: string;
  successText!: string;
  formSubmitted: Boolean = false;
  displayError: Boolean = false;
  displaySuccess: Boolean = false;
  passwordForm= new FormGroup({
    userPass: new FormControl<string>('', [Validators.required]),
    userPassNew: new FormControl<string>('',
      [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(100)
      ])
  });

  constructor(
    public authService: AuthenticationService
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();
  }

  async changePassword() {
    this.formSubmitted = true;

    if(!this.passwordForm.valid) {
      return;
    }

    await this.authService.updatePassword(this.user.email, <string>this.passwordForm.controls['userPass'].value, <string>this.passwordForm.controls['userPassNew'].value).then(() => {
      this.successText = 'Je wachtwoord is succesvol gewijzigd!';
      this.displayError = false;
      this.displaySuccess = true;
      this.formSubmitted = false;
      this.passwordForm.reset();
    }).catch((error) => {
      this.displayError = true;
      this.displaySuccess = false;
      if (error.code == 'auth/wrong-password') {
        this.errorText = "Je hebt een incorrect huidig wachtwoord ingevoerd."
      } else {
        this.errorText = "Er is een onverwachte fout opgetreden."
      }
    });
  }

  /**
   * @return Filled in current password value on password change form.
   */
  get userPass() {
    return this.passwordForm.get('userPass');
  }

  /**
   * @return Filled in new password value on password change form.
   */
  get userPassNew() {
    return this.passwordForm.get('userPassNew');
  }
}
